import React, { useState } from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { Print } from '../../../../components/atoms/icons';
import { formatDate } from '../../../../components/atoms/func';
import AddServiceIcon from '../../../../assets/icons/add-service.png';
import Modal from '../../../../components/organisms/modals';
import Forms from '../../../../components/organisms/forms';
import partnerByIdRes from '../../../../components/api/partner/getByIdRes.json';
import partnerCommissionRes from '../../../../components/api/partner/getPartnerCommissions.json';
import PaymentStatus from './PaymentStatus';

interface Props {
   isLoading: boolean;
   partnerById: typeof partnerByIdRes.data | undefined;
   partnerCommissions: typeof partnerCommissionRes.data | undefined;
   modal: {
     result: any;
     isLoading: boolean;
     handleDelete: () => void;
     onAfterDelete: () => void;
    },
    paymentModal: {
      load: boolean;
      after: () => void;
      result: any;
    },
    widthHandler: {
        minWidth: string,
        width: string,
        maxWidth: string
    },
    handleChangeStartDate: (date: Date | null) => void,
    handleChangeEndDate: (date: Date | null) => void,
    selectedDate: {
      start: string,
      end: string
    },
    formik: any
}

function RenderTableCommission(props: Props) {
  const {
    isLoading, partnerCommissions, partnerById, modal, paymentModal, formik, widthHandler, handleChangeStartDate, handleChangeEndDate, selectedDate,
  } = props;

  const thLabel = React.useMemo(() => ['DATE', 'DATE RANGE', 'QUANTITY', 'AMOUNT', 'COMMISSION', 'PAYMENT'], []);
  const renderModalBody = () => {
    console.log('generating body of date selection modal');
    return (
      <Forms.DateRangePicker
        id="dateRangePicker"
        handleChangeStart={handleChangeStartDate}
        handleChangeEnd={handleChangeEndDate}
        startDate={{ current: new Date(selectedDate.start), max: new Date(selectedDate.end) }}
        endDate={{ current: new Date(selectedDate.end), min: new Date(selectedDate.start) }}
      />
    );
  };

  console.log('rendering commission table....');
  return (
    <div className="table-container mb-4">
      <div className="d-flex justify-content-between align-items-center my-2" style={{ marginLeft: '30px', marginRight: '30px' }}>
        <div className="fz-18 fw-bold">Commission Report</div>
        <Modal.Default
          cancelLabel="Cancel"
          submitLabel="Generate"
          title="Select Date Range"
          body={renderModalBody()}
          onSubmitClose={modal.handleDelete}
          dialogClassName="custom-modal-width"
          isLoading={modal.isLoading}
          result={modal.result}
          onAfterResult={modal.onAfterDelete}
        >
          <div style={{ marginBottom: '2px' }}>
            <button type="button" className="border-0 bg-transparent">
              <img src={AddServiceIcon} alt="addServiceIcon" width={26} style={{ marginBottom: '4px' }} />
            </button>
          </div>
        </Modal.Default>
      </div>
      <Table borderless responsive>
        <thead>
          <tr>
            <th style={widthHandler}>&nbsp;</th>
            {thLabel.map((th) => (
              <th className="thead-content" key={th} style={{ minWidth: '150px' }}>{th}</th>
            ))}
            <th style={widthHandler}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const res = partnerCommissions ? partnerCommissions.length : 0;
            console.log(res);
            if (isLoading || !partnerCommissions || partnerCommissions.length === 0) {
              return (
                <tr>
                  <td colSpan={8}>
                    <div className="w-100 flexible-center my-2 fz-14 align-middle">
                      {isLoading ? <Spinner animation="border" size="sm" /> : <div className="text-center">Data Not Found</div>}
                    </div>
                  </td>
                </tr>
              );
            }
            return (
              partnerCommissions.map((partnerCommission) => (
                <tr key={partnerCommission.id} className="align-middle my-2 fz-14">
                  <td style={widthHandler}>&nbsp;</td>
                  <td style={widthHandler}>{formatDate(partnerCommission.generationDate) ?? '-'}</td>
                  <td>{`${partnerCommission.salesFrom} - ${partnerCommission.salesTo}`}</td>
                  <td>{partnerCommission.totalCount ?? '-'}</td>
                  <td>{partnerCommission.totalSales ?? '-' }</td>
                  <td>{partnerCommission.totalCommission ?? '-' }</td>
                  <td className="fz-14 pe-4 pe-xl-5">
                    <div className="d-flex justify-content-end align-items-center">
                      <PaymentStatus
                        paymentDate={partnerCommission.paymentDate}
                        paymentAmount={partnerCommission.paymentAmount}
                        id={partnerCommission.id}
                        formik={formik}
                        modal={paymentModal}
                      />
                    </div>
                  </td>
                  <td style={widthHandler}>&nbsp;</td>
                </tr>
              ))
            );
          })()}
        </tbody>
      </Table>
    </div>
  );
}

export default React.memo(RenderTableCommission);
